// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import CustomValueInput from '@Molecules/FiltersList/CustomValueInput';
import { SearchFormInterface, DescribeFieldOutput } from 'thehive-sdk';

interface FiltersValuesProps {
    describeField?: DescribeFieldOutput;
    fieldName?: string;
    filter?: Partial<SearchFormInterface>;
    onChange: (value: any, params?: SearchFormInterface['params']) => void;
}

const FiltersValues = ({
    describeField,
    fieldName = '',
    filter,
    onChange,
}: FiltersValuesProps): ReactElement | null => {
    const fieldAttributes = describeField?.attributes.find((attribute) => attribute.name === fieldName);
    const { type = 'string' } = fieldAttributes || {};
    const isPreFillDate = type === 'date' && filter?.operator !== 'custom';

    if (isPreFillDate) {
        return null;
    }

    return (
        <div className="value">
            {!['is empty', 'is not empty'].includes(filter?.operator || '') && (
                <CustomValueInput
                    filter={filter}
                    attribute={fieldAttributes}
                    className="input-full-width"
                    disabled={!fieldAttributes}
                    value={filter?.values}
                    onChange={onChange}
                />
            )}
        </div>
    );
};

export default FiltersValues;
